import { ApiService } from '../apiService'
import type { CreateIpBanRequest, IpBanDto, IpLookupDto, UserIpAddressDto } from '../types/ip'

/**
 * Where accounts connect from, and which addresses are refused.
 *
 * Bans are enforced by the User API from a cache it refreshes every thirty seconds, so a ban
 * placed or lifted here is live within that window, not the instant the request returns.
 */
export const ipApi = {
  getUserAddresses: (userId: string) =>
    ApiService.get<UserIpAddressDto[]>(`/admin/users/${userId}/ip-addresses`),

  lookup: (ip: string) => ApiService.get<IpLookupDto>('/admin/ip/lookup', { ip }),

  listBans: (includeInactive: boolean) =>
    ApiService.get<IpBanDto[]>('/admin/ip/bans', { includeInactive }),

  createBan: (request: CreateIpBanRequest) => ApiService.post<IpBanDto>('/admin/ip/bans', request),

  liftBan: (id: string) => ApiService.delete<void>(`/admin/ip/bans/${id}`),
}
